/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// サイト内全体のコピーガード機能
document.addEventListener("contextmenu", function (e) {
  e.preventDefault();
  return false;
});

// キーボードショートカットも無効化（F12、Ctrl+Shift+I、Ctrl+U等）
document.addEventListener("keydown", function (e) {
  // F12キーを無効化
  if (e.key === "F12") {
    e.preventDefault();
    return false;
  }

  // Ctrl+Shift+I（開発者ツール）を無効化
  if (e.ctrlKey && e.shiftKey && e.key === "I") {
    e.preventDefault();
    return false;
  }

  // Ctrl+U（ソース表示）を無効化
  if (e.ctrlKey && e.key === "u") {
    e.preventDefault();
    return false;
  }

  // Ctrl+S（保存）を無効化
  if (e.ctrlKey && e.key === "s") {
    e.preventDefault();
    return false;
  }

  // Ctrl+A（全選択）を無効化
  if (e.ctrlKey && e.key === "a") {
    e.preventDefault();
    return false;
  }

  // Ctrl+C（コピー）を無効化
  if (e.ctrlKey && e.key === "c") {
    e.preventDefault();
    return false;
  }

  // Ctrl+V（貼り付け）を無効化
  if (e.ctrlKey && e.key === "v") {
    e.preventDefault();
    return false;
  }

  // Ctrl+X（切り取り）を無効化
  if (e.ctrlKey && e.key === "x") {
    e.preventDefault();
    return false;
  }
});

// テキスト選択を無効化
document.addEventListener("selectstart", function (e) {
  e.preventDefault();
  return false;
});

// お気に入りボタンのハートアイコンの色を変更
function changeWishlistIconColor() {
  // product-item内のお気に入りボタンのSVGを取得
  const wishlistIcons = document.querySelectorAll(".c-wishlist-engine__icon svg");

  wishlistIcons.forEach(function (svg) {
    // お気に入りボタンの親要素を取得
    const wishlistButton = svg.closest(".wishlist-engine");

    // お気に入りが追加されているかどうかをチェック
    const isAdded = wishlistButton.getAttribute("data-added") === "true";

    if (isAdded) {
      // お気に入りが追加されている場合のみ色を変更
      svg.setAttribute("stroke", "#F1557D");
      svg.setAttribute("fill", "#F1557D");

      // path要素のstrokeとfill属性も変更
      const paths = svg.querySelectorAll("path");
      paths.forEach(function (path) {
        path.setAttribute("stroke", "#F1557D");
        path.setAttribute("fill", "#F1557D");
      });
    } else {
      // お気に入りが追加されていない場合はデフォルトに戻す
      svg.setAttribute("stroke", "currentColor");
      svg.setAttribute("fill", "none");

      // path要素のstrokeとfill属性もデフォルトに戻す
      const paths = svg.querySelectorAll("path");
      paths.forEach(function (path) {
        path.setAttribute("stroke", "currentColor");
        path.setAttribute("fill", "none");
      });
    }
  });
}

// トップへ戻るボタンの表示・動作を制御する関数
function initTopBtn() {
  const btn = document.querySelector(".c-top-link");
  if (!btn) return;

  // footer要素を取得
  const footer = document.querySelector("footer");

  // SVG要素を取得
  const svg = btn.querySelector("svg");

  // スクロール時の表示制御と色変更
  window.addEventListener("scroll", () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // ボタンの表示制御
    btn.classList.toggle("is-visible", scrollTop > 0);
  });

  // クリック時の動作
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    // スムーズスクロールでトップへ戻る
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    // フォーカスを外す（アクセシビリティ対応）
    btn.blur();
  });

  // キーボード操作対応
  btn.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      btn.click();
    }
  });
}

// DOMContentLoadedイベントリスナー
document.addEventListener("DOMContentLoaded", function () {
  // 初期化時に実行
  changeWishlistIconColor();
  initTopBtn(); // トップへ戻るボタンの初期化

  // 動的に追加される要素に対応するため、MutationObserverを使用
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        changeWishlistIconColor();
      } else if (mutation.type === "attributes" && mutation.attributeName === "data-added") {
        // data-added属性が変更された時も色を更新
        changeWishlistIconColor();
      }
    });
  });

  // ページ全体を監視
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["data-added"],
  });
});

// アコーディオン機能
function initAccordion() {
  const ac_toggle = document.querySelectorAll(".c-acordion__toggle:not([data-accordion-initialized])");

  function toggle() {
    const content = this.nextElementSibling;
    this.classList.toggle("is-active");
    content.classList.toggle("is-open");
  }

  for (let i = 0; i < ac_toggle.length; i++) {
    ac_toggle[i].addEventListener("click", toggle);
    ac_toggle[i].setAttribute("data-accordion-initialized", "true");
  }
}

// 初期化実行
initAccordion();

// quick buyなどの動的コンテンツ読み込み時にもアコーディオンを初期化
document.addEventListener("openable-element:load:end", function () {
  initAccordion();
});

// MutationObserverでDOM変更を監視してアコーディオンを初期化
const accordionObserver = new MutationObserver(function (mutations) {
  let shouldInit = false;
  mutations.forEach(function (mutation) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      // 新しく追加されたノードにアコーディオンが含まれているかチェック
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          if (node.querySelector && node.querySelector(".c-acordion__toggle")) {
            shouldInit = true;
          }
        }
      });
    }
  });

  if (shouldInit) {
    // 少し遅延させてDOMが安定してから初期化
    setTimeout(initAccordion, 100);
  }
});

// ページ全体を監視
accordionObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// フッター上のパンクズリストの背景色の自動調整
function adjustBreadcrumbBackgroundColor() {
  // 741px未満のデバイスでは実行しない
  if (window.innerWidth < 741) {
    return;
  }

  try {
    // フッターセクションを取得
    const footerSection = document.querySelector(".shopify-section--footer");
    if (!footerSection) {
      return;
    }

    // フッターセクション内のパンクズリストを取得（複数のパターンで検索）
    let breadcrumb = footerSection.querySelector(".c-breadcrumb.hidden-phone");

    if (!breadcrumb) {
      breadcrumb = footerSection.querySelector(".c-breadcrumb");
    }

    if (!breadcrumb) {
      breadcrumb = document.querySelector(".c-breadcrumb.hidden-phone");
    }

    if (!breadcrumb) {
      breadcrumb = document.querySelector(".c-breadcrumb");
    }

    if (!breadcrumb) {
      return;
    }

    // main内の最後のセクションを取得
    const main = document.getElementById("main");
    if (!main) {
      return;
    }

    const sections = main.querySelectorAll(".shopify-section");
    if (sections.length === 0) {
      return;
    }

    const lastSection = sections[sections.length - 1];

    // 最後のセクションの背景色を取得
    const sectionStyle = window.getComputedStyle(lastSection);
    let backgroundColor = sectionStyle.backgroundColor;

    // 背景色が透明の場合は白を使用
    if (!backgroundColor || backgroundColor === "rgba(0, 0, 0, 0)" || backgroundColor === "transparent") {
      backgroundColor = "#fff";
    }

    breadcrumb.style.backgroundColor = backgroundColor;
  } catch (error) {
    // エラーが発生してもサイレントに処理
  }
}

// DOM読み込み完了後に実行（複数のイベントで確実に実行）
function initializeBreadcrumbAdjustment() {
  // 少し遅延させてDOMが完全に構築されるのを待つ
  setTimeout(adjustBreadcrumbBackgroundColor, 100);
}

// 複数のイベントで実行
document.addEventListener("DOMContentLoaded", initializeBreadcrumbAdjustment);
window.addEventListener("load", initializeBreadcrumbAdjustment);
window.addEventListener("resize", adjustBreadcrumbBackgroundColor);

// 即座に実行（DOMが既に読み込まれている場合）
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeBreadcrumbAdjustment);
} else {
  initializeBreadcrumbAdjustment();
}

// 374px未満のデバイスのレスポンシブ対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";

    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }

  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

// フェードアップアニメーション
function initFadeUpAnimation() {
  // IntersectionObserverがサポートされているかチェック
  if (!("IntersectionObserver" in window)) {
    // サポートされていない場合は、すべての要素を即座に表示
    const elements = document.querySelectorAll(".c-animation__fadeup");
    elements.forEach((element) => {
      element.classList.add("is-visible");
    });
    return;
  }

  // オブザーバーのオプション設定
  const observerOptions = {
    root: null, // ビューポートを基準にする
    rootMargin: "0px 0px -50px 0px", // 要素が50px上から見えたときにトリガー
    threshold: 0.1, // 要素の10%が見えたときにトリガー
  };

  // オブザーバーのコールバック関数
  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 要素が画面に入った時
        entry.target.classList.add("is-visible");
        // 一度アニメーションが実行されたら監視を停止（パフォーマンス向上のため）
        observer.unobserve(entry.target);
      }
    });
  };

  // オブザーバーを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 対象要素を監視対象に追加
  const animationElements = document.querySelectorAll(".c-animation__fadeup");
  animationElements.forEach((element) => {
    observer.observe(element);
  });
}

// DOM読み込み完了後にフェードアップアニメーションを初期化
document.addEventListener("DOMContentLoaded", function () {
  initFadeUpAnimation();
});

// スムーススクロール時のヘッダーオフセット調整
function initSmoothScrollWithOffset() {
  // すべてのアンカーリンクを取得
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");

      // 空のhrefや#のみの場合は処理しない
      if (!href || href === "#") {
        return;
      }

      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault();

        // PC環境（741px以上）でのみオフセット調整
        let offset = 0;
        if (window.innerWidth >= 741) {
          // ヘッダーの高さを取得
          const header = document.querySelector(".header");
          const announcementBar = document.querySelector(".announcement-bar");

          if (header) {
            offset += header.offsetHeight;
          }
          if (announcementBar) {
            offset += announcementBar.offsetHeight;
          }

          // 追加の余白（必要に応じて調整）
          offset += -10;
        }

        // 要素の位置を取得してオフセット分を引く
        const elementPosition = targetElement.offsetTop - offset;

        // スムーススクロール実行
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    });
  });
}

// DOM読み込み完了後に初期化
document.addEventListener("DOMContentLoaded", function () {
  initSmoothScrollWithOffset();
});

// カートドロワーの開閉状態に応じてShopifyチャットの表示/非表示を制御
let cartDrawerObserver = null; // 重複実行を防ぐためのフラグ

function initCartDrawerChatControl() {
  const cartDrawer = document.querySelector("cart-drawer") || document.querySelector("[data-cart-drawer]") || document.querySelector(".cart-drawer") || document.querySelector("#cart-drawer");

  if (!cartDrawer) {
    return;
  }

  // 既に監視が設定されている場合は重複を避ける
  if (cartDrawerObserver) {
    return;
  }

  // Shopifyチャット要素を探す関数
  function findShopifyChat() {
    const selectors = ["#shopify-chat", "[id*='shopify-chat']", ".shopify-chat", "[class*='shopify-chat']", "#ShopifyChat", "[id*='ShopifyChat']", ".ShopifyChat", "[class*='ShopifyChat']", "#chat", "[id*='chat'][id*='shopify']", "iframe[src*='shopify']", "iframe[src*='chat']"];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        return element;
      }
    }

    return null;
  }

  // カートドロワーが開いているかチェックする関数
  function isCartDrawerOpen() {
    try {
      return cartDrawer && cartDrawer.hasAttribute && cartDrawer.hasAttribute("open");
    } catch (error) {
      // エラーが発生した場合はfalseを返す
      return false;
    }
  }

  // カートドロワー状態を制御する関数
  function handleCartDrawerChange() {
    try {
      const shopifyChat = findShopifyChat();

      if (!shopifyChat || !shopifyChat.style) {
        return;
      }

      const shouldHideChat = isCartDrawerOpen();

      if (shouldHideChat) {
        // カートドロワーが開いた時：Shopifyチャットを非表示
        shopifyChat.style.display = "none";
      } else {
        // カートドロワーが閉じた時：Shopifyチャットの非表示を解除
        shopifyChat.style.display = "";
      }
    } catch (error) {
      // エラーが発生してもサイレントに処理
    }
  }

  // MutationObserverでcart-drawer要素のopen属性の変化を監視
  if (cartDrawer && !cartDrawerObserver) {
    try {
      cartDrawerObserver = new MutationObserver(function (mutations) {
        try {
          mutations.forEach(function (mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "open") {
              handleCartDrawerChange();
            }
          });
        } catch (error) {
          // エラーが発生してもサイレントに処理
        }
      });

      // cart-drawer要素の属性変化を監視
      cartDrawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["open"],
      });
    } catch (error) {
      // Observer設定でエラーが発生してもサイレントに処理
      cartDrawerObserver = null;
    }
  }

  // 初期状態をチェック
  try {
    if (isCartDrawerOpen()) {
      handleCartDrawerChange();
    }
  } catch (error) {
    // 初期状態チェックでエラーが発生してもサイレントに処理
  }
}

// DOM読み込み完了後にカートドロワーチャット制御を初期化（遅延読み込み対応）
document.addEventListener("DOMContentLoaded", function () {
  // 即座に実行
  initCartDrawerChatControl();

  // 遅延読み込みアプリに対応するため、複数のタイミングで実行
  setTimeout(() => initCartDrawerChatControl(), 1000); // 1秒後
  setTimeout(() => initCartDrawerChatControl(), 3000); // 3秒後
  setTimeout(() => initCartDrawerChatControl(), 5000); // 5秒後
  setTimeout(() => initCartDrawerChatControl(), 10000); // 10秒後
});

// ページ読み込み完了後にも実行
window.addEventListener("load", function () {
  setTimeout(() => initCartDrawerChatControl(), 2000); // 2秒後
  setTimeout(() => initCartDrawerChatControl(), 5000); // 5秒後
});

///////////////////////////////////////////////
// BrandStoryページのfullpage.js設定
// ブランドストーリー実行条件
function shouldRunBrandstory() {
  const main = document.getElementById("main");
  return !!(main && main.classList.contains("page-brandstory"));
}

// より厳密な条件チェック
function isBrandstoryPage() {
  const main = document.getElementById("main");
  return main && main.classList.contains("page-brandstory");
}

// CSS変数から高さ取得
function getAnnouncementPx() {
  const cs = getComputedStyle(document.documentElement);
  const ann = parseFloat(cs.getPropertyValue("--announcement-bar-height")) || 0;
  const enA = parseFloat(cs.getPropertyValue("--enable-sticky-announcement-bar")) || 1;
  return ann * enA;
}
function getHeaderPx() {
  const cs = getComputedStyle(document.documentElement);
  const header = parseFloat(cs.getPropertyValue("--header-height")) || 0;
  const enH = parseFloat(cs.getPropertyValue("--enable-sticky-header")) || 1;
  return header * enH;
}

// 先頭セクションの高さを調整（100dvh - (アナウンス + ヘッダー)）
function applyFirstSectionHeight(totalTopPad) {
  if (!isBrandstoryPage()) return;

  const first = document.querySelector("#fullpage > .shopify-section:first-of-type");
  if (!first) return;

  // スマホ（max-width: 740px）の場合は何もしない
  const isMobile = window.innerWidth <= 740;
  if (isMobile) return;

  const h = `calc(100dvh - ${totalTopPad}px)`;

  first.classList.add("fp-auto-height");
  first.style.setProperty("height", h, "important");
  first.style.setProperty("min-height", h, "important");
  first.style.setProperty("max-height", h, "important");

  first.querySelectorAll(".fp-overflow, .video-section--fit-screen, .image-overlay").forEach((el) => {
    el.style.setProperty("height", h, "important");
    el.style.setProperty("max-height", h, "important");
  });
}

// 汎用デバウンス
function debounce(fn, delay) {
  let timerId;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timerId);
    timerId = setTimeout(function () {
      fn.apply(context, args);
    }, delay || 120);
  };
}

// モバイル用：custom-grid-informationセクションの高さを安定したビューポート高で再設定
function adjustGridInformationHeightsMobile() {
  if (!isBrandstoryPage()) return;
  if (window.innerWidth > 740) return;

  const vpH = window.visualViewport ? Math.round(window.visualViewport.height) : window.innerHeight;
  const headerPad = getHeaderPx();
  const h = Math.max(1, vpH - headerPad);
  const sections = document.querySelectorAll(".shopify-section--custom-grid-information");
  sections.forEach((sec) => {
    const slider = sec.querySelector(".c-grid-information__slider");
    if (!slider) return;
    slider.style.setProperty("height", h + "px", "important");

    const slides = slider.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      slide.style.setProperty("height", h + "px", "important");
    });

    // NOTE: update() は残像や不要なslideChangeを誘発するため呼ばない
  });
}

// fullpage の再構築をデバウンス
const debouncedFullpageRebuild = debounce(function () {
  if (window.fullpage_api && typeof window.fullpage_api.reBuild === "function") {
    window.fullpage_api.reBuild();
  }
}, 150);

// --- 追加: “なめらかに”不足分だけスクロールする小ユーティリティ ---
function animateExtraScrollBy(delta, duration = 180) {
  // scrollBar:true なのでネイティブスクロールを操作
  const scroller = document.scrollingElement || document.documentElement;
  const startTop = scroller.scrollTop;
  const start = performance.now();
  const easeOutQuad = (t) => t * (2 - t); // 0→1

  function step(now) {
    const p = Math.min(1, (now - start) / duration);
    const eased = easeOutQuad(p);
    scroller.scrollTop = startTop + delta * eased;
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// 起動
function bootstrapFullpage() {
  if (!isBrandstoryPage()) return;

  document.querySelectorAll(".no-fullpage").forEach((el) => el.remove());

  // max-width: 740pxの時にno-fullpage-spクラスがついた要素を削除
  if (window.innerWidth <= 740) {
    document.querySelectorAll(".no-fullpage-sp").forEach((el) => el.remove());
  }

  requestAnimationFrame(() => requestAnimationFrame(initFullpage));
}

function initFullpage() {
  if (!isBrandstoryPage()) return;

  const fpRoot = document.getElementById("fullpage");
  if (!fpRoot || typeof window.fullpage === "undefined") return;
  if (fpRoot.__fpInited) return;

  // 長いセクションは自動高さ
  fpRoot.querySelectorAll(".shopify-section--custom-scroll-text, .shopify-section--custom-scroll-image-text").forEach((sec) => sec.classList.add("fp-auto-height"));

  // 既存破棄
  if (window.fullpage_api && typeof window.fullpage_api.destroy === "function") {
    window.fullpage_api.destroy("all");
  }

  // 先頭セクションの高さ調整
  const isMobile = window.innerWidth <= 740;
  const totalPad = isMobile ? getHeaderPx() : getAnnouncementPx() + getHeaderPx();
  applyFirstSectionHeight(totalPad);

  // 追加スクロールは 1→2 の時だけ、一度だけ
  let extraAppliedOnce = false;

  // セクション移動後のスクロール移動制御用フラグ
  let sectionScrollDisabled = false;
  let sectionScrollTimer = null;

  const footer = fpRoot.querySelector(".shopify-section--footer");
  if (footer) footer.classList.add("fp-auto-height");

  // スマホでは追従しないヘッダーをnormalScrollElementsに追加
  const normalScrollElements = isMobile ? "footer, .shopify-section--footer, header, .header" : "footer, .shopify-section--footer";

  // fullPage 初期化（標準のスクロール量）
  new fullpage("#fullpage", {
    licenseKey: "8TNUJ-Q71O6-9MLKK-26JGJ-IWZQN", // ライセンスキーを追加
    sectionSelector: "#fullpage > .shopify-section",
    navigation: false,
    autoScrolling: true,
    fitToSection: true,
    scrollBar: !isMobile, // 741px以上ではtrue、740px以下ではfalse
    normalScrollElements: normalScrollElements,
    scrollingSpeed: 1200,
    easingcss3: "ease",
    responsiveWidth: 0,
    responsiveHeight: 0,
    scrollOverflow: true,
    slidesNavigation: false,
    slidesNavPosition: "bottom",
    controlArrows: false,
    loopHorizontal: false,
    // モバイル用のpadding設定
    paddingTop: isMobile ? "0" : "0",
    paddingBottom: isMobile ? "61px" : "0",

    // ★ ここで 1→2 遷移直後に "アナウンスメント分だけ"をスムーズに足す
    afterLoad(origin, destination) {
      // 先頭セクションは .fp-overflow 生成後の再適用（保険）
      if (destination.index === 0) {
        const isMobile = window.innerWidth <= 740;
        // スマホではヘッダー高さのみ、デスクトップではアナウンス+ヘッダー
        const totalPad = isMobile ? getHeaderPx() : getAnnouncementPx() + getHeaderPx();
        applyFirstSectionHeight(totalPad);
      }

      const isMobile = window.innerWidth <= 740;

      // custom-grid-informationセクションでの位置ズレを防ぐ（モバイル時のみ、全体側で一元処理）
      if (destination && destination.item && destination.item.classList.contains("shopify-section--custom-grid-information") && isMobile) {
        requestAnimationFrame(() => {
          // 対象セクションのスライダー高さを視覚ビューポートベースで再設定
          adjustGridInformationHeightsMobile();
          // fullpage の再構築はデバウンスで1回だけ
          debouncedFullpageRebuild();

          // 入場直後に存在するヘッダー分のギャップを即時解消
          try {
            const enteringDown = !origin || (origin && typeof origin.index === "number" && typeof destination.index === "number" && origin.index < destination.index);
            if (enteringDown && !destination.item.__cgMobileScrolledOnce) {
              // レイアウト反映後に測定して不足分だけ加算スクロール
              setTimeout(() => {
                try {
                  const rect = destination.item.getBoundingClientRect();
                  const gap = Math.round(rect.top);
                  const maxGap = Math.max(0, Math.round(getHeaderPx()));
                  const delta = Math.min(Math.max(0, gap), maxGap + 8);
                  if (delta > 0) {
                    animateExtraScrollBy(delta, 120);
                  }
                } catch (e) {}
              }, 0);
              destination.item.__cgMobileScrolledOnce = true;
            }
          } catch (e) {}

          // 直前のホイール残量でスライドが1枚だけ切り替わるのを防止
          try {
            const slider = destination.item.querySelector(".c-grid-information__slider");
            const instance = slider && slider.swiper;
            if (instance && instance.mousewheel && typeof instance.mousewheel.disable === "function" && typeof instance.mousewheel.enable === "function") {
              instance.mousewheel.disable();
              setTimeout(() => {
                try {
                  instance.mousewheel.enable();
                } catch (e) {}
              }, 260);
            }
          } catch (e) {}

          // スライド走査完了まで fullpage を禁止（上から下=最後まで / 下から上=最初まで）
          try {
            const dirUp = origin && origin.index > destination.index; // trueなら下→上
            const slider = destination.item.querySelector(".c-grid-information__slider");
            const instance = slider && slider.swiper;
            if (instance) {
              const total = (instance.slides && instance.slides.length) || slider.querySelectorAll(".swiper-slide").length || 0;
              if (total <= 1) return; // 1枚なら制御不要

              const targetIndex = dirUp ? 0 : total - 1;
              const current = typeof instance.activeIndex === "number" ? instance.activeIndex : 0;

              // すでに到達していなければ、セクションスクロールを禁止
              if (current !== targetIndex) {
                if (window.fullpage_api && typeof window.fullpage_api.setAllowScrolling === "function") {
                  window.fullpage_api.setAllowScrolling(false);
                }
                window.customGridInformationScrollDisabled = true;

                // 既存のガードがあれば解除
                if (instance.__cgMobileGuard) {
                  try {
                    instance.off("slideChange", instance.__cgMobileGuard);
                  } catch (e) {}
                }

                instance.__cgMobileGuard = function () {
                  const idx = typeof instance.activeIndex === "number" ? instance.activeIndex : 0;
                  if (idx === targetIndex) {
                    try {
                      instance.off("slideChange", instance.__cgMobileGuard);
                    } catch (e) {}
                    instance.__cgMobileGuard = null;
                    // 高さを最終適用し、スクロールを再許可
                    adjustGridInformationHeightsMobile();
                    debouncedFullpageRebuild();
                    if (window.fullpage_api && typeof window.fullpage_api.setAllowScrolling === "function") {
                      window.fullpage_api.setAllowScrolling(true);
                    }
                    window.customGridInformationScrollDisabled = false;
                  }
                };

                try {
                  instance.on("slideChange", instance.__cgMobileGuard);
                } catch (e) {}
              }
            }
          } catch (e) {}
        });
      }

      // スマホでは1→2遷移時の追加スクロールを無効化
      if (!extraAppliedOnce && origin && origin.index === 0 && destination.index === 1 && !isMobile) {
        const extra = getAnnouncementPx();
        if (extra > 0) {
          extraAppliedOnce = true;
          // アニメ完了直後の1フレーム後に、ごく短時間で不足分だけ足す
          requestAnimationFrame(() => animateExtraScrollBy(extra, 0));
        }
      }
    },

    // スライド関連のコールバック（無効化）
    afterSlideLoad(anchorLink, index, slideAnchor, slideIndex) {},
    onSlideLeave(anchorLink, index, slideIndex, direction, nextSlideIndex) {},

    // セクション移動前のチェック（スライド移動制御を無効化）
    beforeSlideLoad(anchorLink, index, slideAnchor, slideIndex) {
      return true; // 常に移動を許可
    },

    // セクション移動前のチェック（縦スクロール移動を制御）
    onLeave(origin, destination, direction) {
      // フッターへの移動は制御しない
      const isMovingToFooter = destination && destination.item && destination.item.classList.contains("shopify-section--footer");

      // custom-grid-information.liquidの制御をチェック
      if (window.customGridInformationScrollDisabled && !isMovingToFooter) {
        console.log("Custom Grid Information - Section scroll blocked by custom-grid-information");
        return false; // 移動をキャンセル
      }

      if (sectionScrollDisabled && !isMovingToFooter) {
        return false; // 移動をキャンセル
      }

      // フッターへの移動の場合は許可
      return true;
    },
  });

  // fp構造反映後に再適用（保険）
  requestAnimationFrame(() => applyFirstSectionHeight(totalPad));

  fpRoot.__fpInited = true;
}

document.addEventListener("DOMContentLoaded", bootstrapFullpage);
document.addEventListener("shopify:section:load", bootstrapFullpage);

// リサイズ時にも再適用
let lastWindowWidth = window.innerWidth;
window.addEventListener("resize", () => {
  if (!isBrandstoryPage()) return;

  // スマホではヘッダー高さのみ、デスクトップではアナウンス+ヘッダー
  const isMobile = window.innerWidth <= 740;
  const totalPad = isMobile ? getHeaderPx() : getAnnouncementPx() + getHeaderPx();
  applyFirstSectionHeight(totalPad);

  // モバイル時は custom-grid-information セクションの高さも更新し、reBuildをデバウンス
  if (isMobile) {
    adjustGridInformationHeightsMobile();
    debouncedFullpageRebuild();
  }

  // 画面サイズが変わった場合はfullpage.jsを再初期化
  const currentIsMobile = window.innerWidth <= 740;
  const wasMobile = lastWindowWidth <= 740;

  if (currentIsMobile !== wasMobile) {
    // 画面サイズが変わった場合は再初期化
    setTimeout(() => {
      if (window.fullpage_api && typeof window.fullpage_api.destroy === "function") {
        window.fullpage_api.destroy("all");
      }
      bootstrapFullpage();
    }, 100);
  }

  // リサイズ時にno-fullpage-spクラスの要素を適切に処理
  if (currentIsMobile) {
    document.querySelectorAll(".no-fullpage-sp").forEach((el) => el.remove());
  }

  lastWindowWidth = window.innerWidth;
});

// visualViewport の変化にも追従（モバイルブラウザUIの出現/非表示）
if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", () => {
    if (!isBrandstoryPage()) return;
    if (window.innerWidth > 740) return;
    adjustGridInformationHeightsMobile();
    debouncedFullpageRebuild();
  });
}

///////////////////////////////////////////////
// ProductStoryページのfullpage.js設定
// プロダクトストーリー実行条件
function shouldRunProductstory() {
  const main = document.getElementById("main");
  return !!(main && main.classList.contains("page-productstory"));
}

// より厳密な条件チェック
function isProductstoryPage() {
  const main = document.getElementById("main");
  return main && main.classList.contains("page-productstory");
}

// ProductStory用の先頭セクションの高さを調整（100dvh - (アナウンス + ヘッダー)）
function applyProductstoryFirstSectionHeight(totalTopPad) {
  if (!isProductstoryPage()) return;

  const first = document.querySelector("#fullpage > .shopify-section:first-of-type");
  if (!first) return;

  // スマホ（max-width: 740px）の場合は高さ調整をしない
  const isMobile = window.innerWidth <= 740;
  if (isMobile) return;

  const h = `calc(100dvh - ${totalTopPad}px)`;

  first.classList.add("fp-auto-height");
  first.style.setProperty("height", h, "important");
  first.style.setProperty("min-height", h, "important");
  first.style.setProperty("max-height", h, "important");

  first.querySelectorAll(".fp-overflow, .video-section--fit-screen, .image-overlay").forEach((el) => {
    el.style.setProperty("height", h, "important");
    el.style.setProperty("max-height", h, "important");
  });
}

// ProductStory用のfullpage の再構築をデバウンス
const debouncedProductstoryFullpageRebuild = debounce(function () {
  if (window.fullpage_api && typeof window.fullpage_api.reBuild === "function") {
    window.fullpage_api.reBuild();
  }
}, 150);

// ProductStory用の追加スクロールアニメーション
function animateProductstoryExtraScrollBy(delta, duration = 180) {
  const scroller = document.scrollingElement || document.documentElement;
  const startTop = scroller.scrollTop;
  const start = performance.now();
  const easeOutQuad = (t) => t * (2 - t);

  function step(now) {
    const p = Math.min(1, (now - start) / duration);
    const eased = easeOutQuad(p);
    scroller.scrollTop = startTop + delta * eased;
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// フッターを#fullpageの直下に移動する関数
function moveFooterToFullpage() {
  const fullpage = document.getElementById("fullpage");
  const footerGroup = document.querySelector(".shopify-section-group-footer-group");

  if (!fullpage || !footerGroup) return;

  // フッターグループを#fullpageの最後に移動
  fullpage.appendChild(footerGroup);

  // fp-auto-heightクラスを付与
  footerGroup.classList.add("fp-auto-height");

  // mobileFixedMenuを#mainの外（隣接）に移動
  moveMobileFixedMenu();
}

// mobileFixedMenuを#mainの外（隣接）に移動する関数
function moveMobileFixedMenu() {
  const main = document.getElementById("main");
  const mobileFixedMenu = document.getElementById("mobileFixedMenu");

  console.log("moveMobileFixedMenu - main:", main);
  console.log("moveMobileFixedMenu - mobileFixedMenu:", mobileFixedMenu);

  if (!main || !mobileFixedMenu) {
    console.log("moveMobileFixedMenu - 要素が見つかりません");
    return;
  }

  console.log("moveMobileFixedMenu - 移動前の位置:", mobileFixedMenu.parentNode);

  // mobileFixedMenuを#mainの隣接要素として移動
  main.parentNode.insertBefore(mobileFixedMenu, main.nextSibling);

  console.log("moveMobileFixedMenu - 移動後の位置:", mobileFixedMenu.parentNode);
}

// ProductStory用の起動
function bootstrapProductstoryFullpage() {
  if (!isProductstoryPage()) return;

  document.querySelectorAll(".no-fullpage").forEach((el) => el.remove());

  // max-width: 740pxの時にno-fullpage-spクラスがついた要素を削除
  if (window.innerWidth <= 740) {
    document.querySelectorAll(".no-fullpage-sp").forEach((el) => el.remove());

    // 740px以下の時にフッターを#fullpageの直下に移動
    moveFooterToFullpage();
  }

  requestAnimationFrame(() => requestAnimationFrame(initProductstoryFullpage));
}

function initProductstoryFullpage() {
  if (!isProductstoryPage()) return;

  const fpRoot = document.getElementById("fullpage");
  if (!fpRoot || typeof window.fullpage === "undefined") return;
  if (fpRoot.__fpProductstoryInited) return;

  // 長いセクションは自動高さ
  fpRoot.querySelectorAll(".shopify-section--custom-scroll-text, .shopify-section--custom-scroll-image-text").forEach((sec) => sec.classList.add("fp-auto-height"));

  // 既存破棄
  if (window.fullpage_api && typeof window.fullpage_api.destroy === "function") {
    window.fullpage_api.destroy("all");
  }

  // 先頭セクションの高さ調整（デスクトップのみ）
  const isMobile = window.innerWidth <= 740;
  if (!isMobile) {
    const totalPad = getAnnouncementPx() + getHeaderPx();
    applyProductstoryFirstSectionHeight(totalPad);
  }

  // 追加スクロールは 1→2 の時だけ、一度だけ
  let extraAppliedOnce = false;

  // セクション移動後のスクロール移動制御用フラグ
  let sectionScrollDisabled = false;
  let sectionScrollTimer = null;

  const footer = fpRoot.querySelector(".shopify-section--footer");
  if (footer) footer.classList.add("fp-auto-height");

  // スマホでは追従しないヘッダーをnormalScrollElementsに追加
  const normalScrollElements = isMobile ? "footer, .shopify-section--footer, header, .header" : "";

  // fullPage 初期化（標準のスクロール量）
  new fullpage("#fullpage", {
    licenseKey: "8TNUJ-Q71O6-9MLKK-26JGJ-IWZQN", // ライセンスキーを追加
    sectionSelector: "#fullpage > .shopify-section",
    navigation: false,
    autoScrolling: true,
    fitToSection: true,
    scrollBar: !isMobile, // 741px以上ではtrue、740px以下ではfalse
    normalScrollElements: normalScrollElements,
    scrollingSpeed: 1200,
    easingcss3: "ease",
    responsiveWidth: 0,
    responsiveHeight: 0,
    scrollOverflow: true,
    slidesNavigation: false,
    slidesNavPosition: "bottom",
    controlArrows: false,
    loopHorizontal: false,
    // モバイル用のpadding設定
    paddingTop: isMobile ? "0" : "0",
    paddingBottom: isMobile ? "61px" : "0",

    // ProductStory用のafterLoadコールバック
    afterLoad(origin, destination) {
      // 先頭セクションは .fp-overflow 生成後の再適用（保険、デスクトップのみ）
      if (destination.index === 0) {
        const isMobile = window.innerWidth <= 740;
        if (!isMobile) {
          const totalPad = getAnnouncementPx() + getHeaderPx();
          applyProductstoryFirstSectionHeight(totalPad);
        }
      }

      const isMobile = window.innerWidth <= 740;

      // スマホでは1→2遷移時の追加スクロールを無効化
      if (!extraAppliedOnce && origin && origin.index === 0 && destination.index === 1 && !isMobile) {
        const extra = getAnnouncementPx();
        if (extra > 0) {
          extraAppliedOnce = true;
          requestAnimationFrame(() => animateProductstoryExtraScrollBy(extra, 0));
        }
      }
    },

    // スライド関連のコールバック（無効化）
    afterSlideLoad(anchorLink, index, slideAnchor, slideIndex) {},
    onSlideLeave(anchorLink, index, slideIndex, direction, nextSlideIndex) {},

    // セクション移動前のチェック（スライド移動制御を無効化）
    beforeSlideLoad(anchorLink, index, slideAnchor, slideIndex) {
      return true;
    },

    // セクション移動前のチェック（縦スクロール移動を制御）
    onLeave(origin, destination, direction) {
      const isMovingToFooter = destination && destination.item && destination.item.classList.contains("shopify-section--footer");

      if (window.customGridInformationScrollDisabled && !isMovingToFooter) {
        console.log("ProductStory Custom Grid Information - Section scroll blocked by custom-grid-information");
        return false;
      }

      if (sectionScrollDisabled && !isMovingToFooter) {
        return false;
      }

      return true;
    },
  });

  // fp構造反映後に再適用（保険、デスクトップのみ）
  if (!isMobile) {
    const totalPad = getAnnouncementPx() + getHeaderPx();
    requestAnimationFrame(() => applyProductstoryFirstSectionHeight(totalPad));
  }

  fpRoot.__fpProductstoryInited = true;
}

document.addEventListener("DOMContentLoaded", () => {
  bootstrapProductstoryFullpage();

  // 740px以下の時にフッターを#fullpageの直下に移動
  if (window.innerWidth <= 740) {
    moveFooterToFullpage();
  }
});
document.addEventListener("shopify:section:load", bootstrapProductstoryFullpage);

// ProductStory用のリサイズ時にも再適用
let lastProductstoryWindowWidth = window.innerWidth;
window.addEventListener("resize", () => {
  if (!isProductstoryPage()) return;

  const isMobile = window.innerWidth <= 740;
  if (!isMobile) {
    const totalPad = getAnnouncementPx() + getHeaderPx();
    applyProductstoryFirstSectionHeight(totalPad);
  }

  const currentIsMobile = window.innerWidth <= 740;
  const wasMobile = lastProductstoryWindowWidth <= 740;

  if (currentIsMobile !== wasMobile) {
    setTimeout(() => {
      if (window.fullpage_api && typeof window.fullpage_api.destroy === "function") {
        window.fullpage_api.destroy("all");
      }
      bootstrapProductstoryFullpage();
    }, 100);
  }

  if (currentIsMobile) {
    document.querySelectorAll(".no-fullpage-sp").forEach((el) => el.remove());
    // モバイル表示時にフッターを移動
    moveFooterToFullpage();
  }

  lastProductstoryWindowWidth = window.innerWidth;
});

///////////////////////////////////////////////
// 特典商品の重複購入防止（同一ランク=同一variant_id は常に数量1に強制）
// - Shopify Functions を使わず、テーマJSで「入れ替え（既存があれば維持/重複は削除）」＋「保険（2以上なら1へ丸め）」を行う
// - 対象variant_idは `snippets/js-variables.liquid` の window.themeVariables.presentVariantIds に集約
///////////////////////////////////////////////

(() => {
  const tv = window.themeVariables;
  const presentVariantIds = tv?.presentVariantIds;
  const routes = tv?.routes;

  if (!presentVariantIds || !routes?.cartUrl || !routes?.cartAddUrl || !routes?.cartChangeUrl) return;

  const presentIds = Object.values(presentVariantIds)
    .map((v) => Number(v))
    .filter((v) => Number.isFinite(v));
  const presentIdSet = new Set(presentIds);
  if (presentIdSet.size === 0) return;

  const CART_URL = `${routes.cartUrl}.js`; // /cart.js
  const CART_ADD_URL = `${routes.cartAddUrl}.js`; // /cart/add.js
  const CART_CHANGE_URL = `${routes.cartChangeUrl}.js`; // /cart/change.js

  let enforcing = false;
  let pendingEnforce = false;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  async function fetchCart() {
    const res = await fetch(CART_URL, { cache: "no-store", credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return await res.json();
  }

  async function changeItemByKey(key, quantity) {
    const res = await fetch(CART_CHANGE_URL, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error("Failed to change cart item");
    return await res.json();
  }

  function buildPresentFixOps(cart) {
    /** @type {{key: string, quantity: number}[]} */
    const ops = [];

    if (!cart?.items?.length) return ops;

    for (const presentId of presentIdSet) {
      const items = cart.items.filter((it) => Number(it.variant_id) === presentId);
      if (items.length === 0) continue;

      const totalQty = items.reduce((sum, it) => sum + Number(it.quantity || 0), 0);
      if (totalQty <= 1 && items.length === 1 && Number(items[0].quantity || 0) <= 1) continue;

      // 1つ目を数量1で残し、それ以外は削除（数量0）
      items.forEach((it, idx) => {
        if (!it?.key) return;
        ops.push({ key: it.key, quantity: idx === 0 ? 1 : 0 });
      });
    }

    return ops;
  }

  async function dispatchCartEvents(cart) {
    // テーマ側が参照するイベントに揃える
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart } }));
  }

  async function enforcePresentQuantities(cartMaybe) {
    if (enforcing) {
      pendingEnforce = true;
      return;
    }

    enforcing = true;
    try {
      // 画面描画が入れ替わっている最中に叩くと競合しやすいので、軽く待つ
      await sleep(0);

      let cart = cartMaybe;
      if (!cart || !cart.items) cart = await fetchCart();

      const ops = buildPresentFixOps(cart);
      if (ops.length === 0) return;

      // 逐次で矯正（並列にするとカート状態がズレやすい）
      for (const op of ops) {
        await changeItemByKey(op.key, op.quantity);
      }

      // 矯正後の最新カートを配信
      cart = await fetchCart();
      await dispatchCartEvents(cart);
    } catch (e) {
      // 失敗しても致命傷にしない（ログのみ）
      console.warn("[present] enforce failed", e);
    } finally {
      enforcing = false;
      if (pendingEnforce) {
        pendingEnforce = false;
        // 連続イベントに備えて再実行
        enforcePresentQuantities().catch(() => {});
      }
    }
  }

  function extractVariantIdFromHref(href) {
    if (!href) return null;

    // /cart/add/<variant_id>
    const m1 = href.match(/\/cart\/add\/(\d+)/);
    if (m1?.[1]) return Number(m1[1]);

    // /cart/<variant_id>:<qty>
    const m2 = href.match(/\/cart\/(\d+):(\d+)/);
    if (m2?.[1]) return Number(m2[1]);

    return null;
  }

  async function addOrSwapPresentVariant(variantId) {
    // variantId 以外の特典は消さない（FRIEND+VIP+VVIPの同時所持はOK）
    // ただし、同一variantが複数行/数量2以上になっていたら 1 に揃える
    try {
      const cart = await fetchCart();
      const items = cart.items?.filter((it) => Number(it.variant_id) === Number(variantId)) ?? [];

      if (items.length === 0) {
        // 未追加なら追加
        const res = await fetch(CART_ADD_URL, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });

        if (!res.ok) {
          // 失敗時は何もしない（テーマ側のUIはそのまま）
          return;
        }
      }

      // 念のため最終的に「同一特典は1」に矯正
      await enforcePresentQuantities();
    } catch (e) {
      console.warn("[present] add/swap failed", e);
    }
  }

  // クリック導線（特典一覧のリンク直叩き）を入れ替え動作に置き換える
  document.addEventListener(
    "click",
    (event) => {
      const a = event.target?.closest?.("a");
      if (!a) return;

      const href = a.getAttribute("href") || "";
      const variantId = extractVariantIdFromHref(href);
      if (!variantId || !presentIdSet.has(variantId)) return;

      // 特典商品のリンク追加はJSで制御
      event.preventDefault();
      event.stopPropagation();

      addOrSwapPresentVariant(variantId).then(() => {
        // 既存テーマの挙動を大きく変えない（drawerなら開く、pageなら/cartへ）
        if (tv.settings?.cartType === "drawer") {
          const miniCart = document.getElementById("mini-cart");
          if (miniCart) miniCart.open = true;
        } else {
          window.location.href = routes.cartUrl;
        }
      });
    },
    true
  );

  // 追加・更新後に「保険」で必ず1に丸める
  document.documentElement.addEventListener("cart:updated", (event) => {
    enforcePresentQuantities(event?.detail?.cart).catch(() => {});
  });
  document.documentElement.addEventListener("cart:refresh", (event) => {
    enforcePresentQuantities(event?.detail?.cart).catch(() => {});
  });
})();
